import { gql } from '@apollo/client'

export const PROFILE_OVERVIEW = gql`
  query ProfileOverview(
    $includeMarketplaceListing: Boolean = false
    $upcomingStartDateTime: DateTimeRangeInput
  ) {
    lessonTypes @include(if: $includeMarketplaceListing) {
      id
      status
    }
    currentUser {
      groupEvents(
        startDateTime: $upcomingStartDateTime
        includeCanceled: false
      ) @include(if: $includeMarketplaceListing) {
        startDateTime
        tags
        registrationClosed
        registrationFull
        hasWaitlist
        sessions {
          startDateTime
        }
      }
      attributes {
        ... on Coach {
          hasPaidTierSubscription
          canPromoteContent
          bookingUrl
          freeTierLimitsReached
          preferences {
            acceptsLeads
          }
          facilities {
            id
            name
            coachProfilesFacilities {
              visible
            }
          }
          coachProfile {
            coachProfileId
            firstName
            lastName
            profilePhoto
            title
            status
            bookable
            city
            state
            customSlug
            facilities {
              facilityName
              city
              state
            }
            coach {
              canPromoteContent
            }
          }
        }
      }
    }
  }
`

// Kept separate from PROFILE_OVERVIEW so the slower analytics and lead counts
// never block rendering the rest of the profile card.
export const PROFILE_OVERVIEW_ANALYTICS = gql`
  query ProfileOverviewAnalytics(
    $startDate: ISO8601Date!
    $endDate: ISO8601Date!
    $previousStartDate: ISO8601Date!
    $previousEndDate: ISO8601Date!
  ) {
    coachingInquiries {
      id
      createdAt
    }
    currentUser {
      coachProfileAnalytics(startDate: $startDate, endDate: $endDate) {
        impressions
        views
      }
      previousCoachProfileAnalytics: coachProfileAnalytics(
        startDate: $previousStartDate
        endDate: $previousEndDate
      ) {
        impressions
        views
      }
    }
  }
`
